<p-dialog
  header="Publish to S3"
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  (onShow)="onOpen()"
  [modal]="true"
  [style]="{ width: '460px' }"
  appendTo="body"
>
  <div class="flex flex-col gap-3 pt-2">
    @if (published()) {
      <p class="text-[0.8rem] text-wb-muted m-0">
        "{{ slug() }}" is already published. Choose how to update it.
      </p>

      <label class="mode-option" [class.mode-option--active]="mode() === 'diff'">
        <p-radiobutton name="publishMode" value="diff" [ngModel]="mode()" (ngModelChange)="mode.set($event)" inputId="publishModeDiff" />
        <span class="flex flex-col gap-0.5">
          <span class="text-[0.85rem] text-wb-text">Diff <span class="text-wb-muted">(recommended)</span></span>
          <span class="text-[0.75rem] text-wb-muted">
            Uploads only media that changed. Files the project no longer uses are removed.
          </span>
        </span>
      </label>

      <label class="mode-option" [class.mode-option--active]="mode() === 'replace'">
        <p-radiobutton name="publishMode" value="replace" [ngModel]="mode()" (ngModelChange)="mode.set($event)" inputId="publishModeReplace" />
        <span class="flex flex-col gap-0.5">
          <span class="text-[0.85rem] text-wb-text">Replace all</span>
          <span class="text-[0.75rem] text-wb-muted">
            Re-uploads every file. Slower — use when the published copy can't be trusted.
          </span>
        </span>
      </label>
    } @else {
      <p class="text-[0.8rem] text-wb-muted m-0">
        Publish "{{ slug() }}" to the public S3 bucket? The embed will then work independently of this backend.
      </p>
    }

    <label class="flex items-start gap-2.5 cursor-pointer">
      <p-checkbox inputId="publishSubtitles" [binary]="true" [ngModel]="subtitles()" (ngModelChange)="subtitles.set($event)" />
      <span class="flex flex-col gap-0.5">
        <span class="text-[0.85rem] text-wb-text">Publish subtitles</span>
        <span class="text-[0.75rem] text-wb-muted">
          Rebuilds subtitle files from the uploaded SRT/VTT. Leave off to keep subtitles edited directly in the bucket.
        </span>
      </span>
    </label>
  </div>

  <ng-template #footer>
    <div class="flex justify-end gap-2 pt-2">
      <p-button label="Cancel" severity="secondary" (click)="cancel()" />
      <p-button label="Publish" (click)="confirm()" />
    </div>
  </ng-template>
</p-dialog>
